import { useState } from "react";
import { Minimal } from "..";
import {
  CardHeader,
  ListItemButton,
  ListItemText,
  Loading,
} from "../../components";
import { FiltroAvancadoDialog, VisualizarRelatorioDialog } from "./components";
import shortid from "shortid";
import { formatDate } from "../../utils";
import { history } from "../../services";
import "./relatorios.style.scss";

const RelatoriosLayout = ({
  subgruposRelatorios,
  loading,
  filtrosAplicadosImpressao,
  dadosRelatorioResumido,
  setFiltrosAplicadosImpressao,
  filtrosAvancados,
  setFiltrosAvancados,
  configuracoes,
}) => {
  const [propriedadeRelatorio, setPropriedadeRelatorio] = useState({});
  const [openFiltroAvancadoDialog, setOpenFiltroAvancadoDialog] =
    useState(false);
  const [abrirDialogoVisualizarRelatorio, setAbrirDialogoVisualizarRelatorio] =
    useState(false);
  const [validationError, setValidationError] = useState([]);

  const onClickOpenFiltroAvancadoDialog = (propriedade, subgrupo) => {
    if (propriedade.dashboard && propriedade.dashboardUrl) {
      history.push(propriedade.dashboardUrl);
      return;
    }
    setFiltrosAvancados({
      dataInicial: formatDate.toSend(new Date()),
      dataFinal: formatDate.toSend(new Date()),
      dataReferencia: formatDate.toSend(new Date()),
    });
    setPropriedadeRelatorio({ ...propriedade, subgrupo });
    setOpenFiltroAvancadoDialog(true);
  };

  return (
    <Minimal>
      {subgruposRelatorios.map(
        ({ subgrupo, propriedades, subgrupoDescricao }) => (
          <div key={shortid.generate()}>
            <CardHeader title={subgrupo} />
            {propriedades
              .filter((propriedade) => propriedade.permissao)
              .map((propriedade) => (
                <ListItemButton
                  key={shortid.generate()}
                  className="shadow-card-light"
                  onClick={() =>
                    onClickOpenFiltroAvancadoDialog(
                      propriedade,
                      subgrupoDescricao || subgrupo
                    )
                  }
                >
                  <ListItemText primary={propriedade.name} />
                  <i className="ph-fill ph-funnel" style={{ fontSize: 18 }}></i>
                </ListItemButton>
              ))}
          </div>
        )
      )}
      <Loading loading={loading} />
      <FiltroAvancadoDialog
        filtrosAvancados={filtrosAvancados}
        setFiltrosAvancados={setFiltrosAvancados}
        filtrosAplicadosImpressao={filtrosAplicadosImpressao}
        setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
        setOpenFiltroAvancadoDialog={setOpenFiltroAvancadoDialog}
        openFiltroAvancadoDialog={openFiltroAvancadoDialog}
        propriedadeRelatorio={propriedadeRelatorio}
        setAbrirDialogoVisualizarRelatorio={setAbrirDialogoVisualizarRelatorio}
        relatoriosTotais={dadosRelatorioResumido}
        configuracoes={configuracoes}
        validationError={validationError}
      >
        <propriedadeRelatorio.formulario
          filtrosAvancados={filtrosAvancados}
          setFiltrosAvancados={setFiltrosAvancados}
          filtrosAplicadosImpressao={filtrosAplicadosImpressao}
          setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
          setValidationError={setValidationError}
        />
      </FiltroAvancadoDialog>
      <VisualizarRelatorioDialog
        setAbrirDialogoVisualizarRelatorio={setAbrirDialogoVisualizarRelatorio}
        abrirDialogoVisualizarRelatorio={abrirDialogoVisualizarRelatorio}
        propriedadeRelatorio={propriedadeRelatorio}
        filtrosAplicadosImpressao={filtrosAplicadosImpressao}
        setFiltrosAplicadosImpressao={setFiltrosAplicadosImpressao}
        setFiltrosAvancados={setFiltrosAvancados}
        dadosRelatorioResumido={dadosRelatorioResumido}
        setOpenFiltroAvancadoDialog={setOpenFiltroAvancadoDialog}
      />
    </Minimal>
  );
};

export default RelatoriosLayout;
